import { useCallback } from 'react';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';

import useCopyPasteSteps from './solve/useCopyPasteSteps';
import { Roles } from 'src/components/app/types';
import {
  selectUser,
  selectUserRole,
} from 'src/reducers/userReducer/userReducer';
import * as API from 'src/services/api';

export const logout = async (sessionId?: number, userRole?: Roles) => {
  if (IS_ZENDESK_BUILD) {
    const returnTo = encodeURIComponent(window.location.href);
    window.location.assign(`/access/logout?return_to=${returnTo}`);
    return;
  }
  localStorage.removeItem('org');
  await API.emitTrackingEventApi({
    eventType: 'dashboard-sign-out',
    sessionId: sessionId as number,
    userRole: userRole as Roles,
  });
  API.logoutUser();
  Auth.signOut();
};

export const useLogout = () => {
  const user = useSelector(selectUser);
  const userRole = useSelector(selectUserRole);
  const { auth_time: sessionId } = user?.user ?? {};
  const { resetCopyPasteSteps } = useCopyPasteSteps();

  const curriedLogout = useCallback(async () => {
    await logout(sessionId, userRole);
    resetCopyPasteSteps();
  }, [sessionId, userRole, resetCopyPasteSteps]);

  return curriedLogout;
};
